import React from 'react';
import { Dayjs } from 'dayjs';
import { Text } from 'components/Typography';
import { centsToDollarsDisplay, formatDateForUILongFormat, ITipCalculatorPoolTotals } from 'utils';
import Sidebar from './components/Sidebar';
import { Content, RowItem } from './components/styles';

interface ITipCalcPoolsSidebarProps {
  dataCy?: string;
  businessDate: Dayjs;
  totals: ITipCalculatorPoolTotals;
  onBack: () => void;
}

const TipCalcPoolsSidebar = ({ businessDate, totals, onBack, dataCy = 'tip-calc-pools-sidebar' }: ITipCalcPoolsSidebarProps) => (
  <Sidebar title="Pool Details" leftActionButton={{ label: 'Back', appearance: 'white', onClick: onBack }} dataCy={dataCy}>
    <Content>
      <RowItem data-cy={`${dataCy}-business-date`} className="business-date">
        <Text size="small" data-cy={`${dataCy}-business-date-label`}>
          Business Date:
        </Text>
        <Text size="small" data-cy={`${dataCy}-business-date-value`}>
          {formatDateForUILongFormat(businessDate)}
        </Text>
      </RowItem>
      <RowItem data-cy={`${dataCy}-pooled-total`}>
        <Text size="small" data-cy={`${dataCy}-pooled-total-label`}>
          Pooled Tips & Autograts:
        </Text>
        <Text size="small" data-cy={`${dataCy}-pooled-total-value`}>
          {centsToDollarsDisplay(totals.pooledTotal)}
        </Text>
      </RowItem>
      <RowItem data-cy={`${dataCy}-retained-total`}>
        <Text size="small" data-cy={`${dataCy}-retained-total-label`}>
          Retained Tips & Autograts:
        </Text>
        <Text size="small" data-cy={`${dataCy}-retained-total-value`}>
          {centsToDollarsDisplay(totals.retainedTotal)}
        </Text>
      </RowItem>
      {totals.retainedHouse !== undefined && (
        <RowItem data-cy={`${dataCy}-retained-house-total`}>
          <Text size="small" data-cy={`${dataCy}-retained-house-total-label`}>
            Retained by House:
          </Text>
          <Text size="small" data-cy={`${dataCy}-retained-house-total-value`}>
            {centsToDollarsDisplay(totals.retainedHouse)}
          </Text>
        </RowItem>
      )}
      <RowItem data-cy={`${dataCy}-total-tips-autograts`}>
        <Text size="small" data-cy={`${dataCy}-total-tips-autograts-label`}>
          Total Tips & Autograts
        </Text>
        <Text size="small" data-cy={`${dataCy}-total-tips-autograts-value`}>
          {centsToDollarsDisplay(totals.pooledTotal + totals.retainedTotal + (totals.retainedHouse ?? 0))}
        </Text>
      </RowItem>
    </Content>
  </Sidebar>
);

export default TipCalcPoolsSidebar;
